function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagAR(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURXmv33604oO35Ya65/39/fj4+PLy8vSzLtt6LOq7lu+nLeSSOHWH9j8AAAFOSURBVDjL7VNBTsMwENz8wMkL2vgDKHyAA+acg71SxaUX+8IDIsEdWnqFqn1Bkfgks3ZSkpSmJ8SFkb2zOzu2EktL19O4oosGLVRVGqx7DR3VspxROQGt9bShlBuK+RxczFPdcUqxZpQXRX6CAsdA2IqOmpSJi07J+4YzUKTyPMNGkBhJJIQMulIERWVEGaFWspFnBD3m6EhPRamFasXv+Ou4ncbNyHC3304azG61ej81mGN5vzl8bmzfUJNzzlpjUtwdmubjzZikCGqy1kaPRN40TfP0nFomIt7QwS5eYXhcS9ppA4NbvMDQrPtSTT4yO7Bvb0DhPSRoDEMAvGcXmNtv8MF5Zg81wBC8dBDFGf9iG9KZwIH9kjh2WKTAD/IOksR7RV1SGAAvuR0IY0PYD/unhjGWo+Gt4jo/3dVwgn+YbpCuLkx39T/dfzTdX+4U/fZFQfMoAAAAAElFTkSuQmCC",
    alt: "AR"
  }, props));
}